import EfAniSticky, { EfAniStickyItem } from '@elem/ui/ef-ani-sticky';
import EfImg from '@elem/ui/ef-img';
import SectionA from '../SectionA';
import SectionB from '../SectionB';
import styles from './index.module.scss';

export default function TheComp() {
    return (
        <div className={`${styles.TheComp} ani-sticky-a`}>
            <EfAniSticky scrollPercent={[0.5, 1]}>
                <EfAniStickyItem>
                    <SectionA />
                </EfAniStickyItem>
                <EfAniStickyItem>
                    <SectionB />
                </EfAniStickyItem>
                <EfImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1725605041186/pc_Long-lasting.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1725605096374/m_Long-lasting.jpg"
                />
            </EfAniSticky>
        </div>
    );
}
